export default __webpack_public_path__ + "media/titles/title_5_locale_en-40658ed5.png";